jQuery(document).ready(function(){
	if (jQuery('body').hasClass('product')) {
		/*var scroll_height = 0;
		var header_ht = jQuery('#shopify-section-header').outerHeight();
		var banner_ht = jQuery('.header-banner-container').outerHeight();
		var scroll_height = parseInt(header_ht)+parseInt(banner_ht);
		var window_width = jQuery(window).width();
		var container_width = jQuery('.section.product_section').width();
		var side_space = parseFloat((window_width-container_width)/2);
		console.log(window_width+' window_width '+window_width+' side_space '+side_space);
		if (window_width >= 1024) {	
			jQuery(window).scroll(function() {    
			    var scroll = jQuery(window).scrollTop();
			    if (scroll >= scroll_height) {
			    	jQuery("body").addClass("hasStikeySidebar");
			        jQuery("#productDespContainer").addClass("stikeySidebar").css('right',side_space+'px');
			    } else {
			        jQuery("body").removeClass("hasStikeySidebar");
			        jQuery("#productDespContainer").removeClass("stikeySidebar").css('right','0');
			    }
			});
		}*/
		//sticky_relocate();
	}
});

function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var footer_top = $("#shopify-section-footer").offset().top;
    var div_top = $('.container.main.content.main-wrapper').offset().top;
    var div_height = $("#productDespContainer").height();

    var padding = 20;  // tweak here or get from margins etc

    if (window_top + div_height > footer_top - padding)
        $('#productDespContainer').css({top: (window_top + div_height - footer_top + padding) * -1})
    else if (window_top > div_top) {
        $('#productDespContainer').addClass('stick');
        $('#productDespContainer').css({top: 0})
    } else {
        $('#productDespContainer').removeClass('stick');
    }
}